export const TOGGLE_APP_CONTRAST = 'TOGGLE_APP_CONTRAST';
export const TOGGLE_ANIMATIONS_AVAILABILITY = 'TOGGLE_ANIMATIONS_AVAILABILITY';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const RESET_TO_DEFAULT_SETTINGS = 'RESET_TO_DEFAULT_SETTINGS';
